import type { ComponentChildren } from 'preact';
import { PageFiltersButton } from './PageFiltersButton';
import { cn } from '@/lib/cn';

export interface PageHeaderProps {
  kicker?: ComponentChildren;
  title: ComponentChildren;
  titleHint?: ComponentChildren;
  description?: ComponentChildren;
  actions?: ComponentChildren;
  meta?: ComponentChildren;
  tabs?: ComponentChildren;
  className?: string;
}

export function PageHeader({
  kicker: _kicker,
  title,
  titleHint,
  description,
  actions,
  meta,
  tabs,
  className,
}: PageHeaderProps) {
  return (
    <header className={cn('flex flex-col gap-4', className)}>
      {/* Fila 1: título (izq) + acciones de la página (der). Los botones que
          varían por página (Exportar, Refrescar, Nuevo…) viven aquí y NO
          afectan a la posición de los tabs. `md:min-h-8` reserva la altura de
          un botón sm (32px) aunque la página no tenga acciones → la fila mide
          lo mismo con o sin botones y los tabs/contenido de abajo quedan
          alineados al cambiar de pestaña. */}
      <div className="flex flex-col gap-3 md:min-h-8 md:flex-row md:items-start md:justify-between">
        <div className="flex min-w-0 flex-col gap-1.5">
          {/* flex-wrap: en móvil el badge baja de línea en vez de cortar el
              título ("Productos y ofe…"). */}
          <div className="flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1">
            <h1 className="text-fg-strong min-w-0 text-2xl leading-tight font-semibold tracking-tight break-words">
              {title}
            </h1>
            {titleHint ?? null}
          </div>
          {description ? (
            <p className="text-fg-muted max-w-2xl text-sm leading-relaxed">{description}</p>
          ) : null}
          {meta ? <div className="mt-1 flex flex-wrap items-center gap-2">{meta}</div> : null}
        </div>
        <div className="flex shrink-0 flex-wrap items-center gap-2">
          {/* En móvil, la única entrada a los filtros de la página. */}
          <PageFiltersButton />
          {actions}
        </div>
      </div>
      {/* Fila 2: tabs en su PROPIA fila, alineados a la izquierda y a ancho
          completo → posición fija, ningún botón los desplaza. */}
      {tabs ? <div className="flex min-w-0">{tabs}</div> : null}
    </header>
  );
}
